import { render, staticRenderFns } from "./TagDetailsPage.vue?vue&type=template&id=0307d1e6&"
import script from "./TagDetailsPage.vue?vue&type=script&lang=js&"
export * from "./TagDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./TagDetailsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports